import { motion } from 'framer-motion';

/**
 * ScrollReveal — wraps children in a Framer Motion element that
 * animates into view as the user scrolls down the page.
 *
 * Props:
 *   children  — content to reveal
 *   delay     — stagger delay in seconds (default 0)
 *   direction — 'up' | 'down' | 'left' | 'right' (default 'up')
 *   duration  — animation duration in seconds (default 0.7)
 *   className — extra CSS classes applied to the wrapper
 *   once      — if true (default), only animates the first time it enters view
 */
const directionMap = {
  up:    { y: 40, x: 0 },
  down:  { y: -40, x: 0 },
  left:  { x: 40, y: 0 },
  right: { x: -40, y: 0 },
};

const ScrollReveal = ({
  children,
  delay = 0,
  direction = 'up',
  duration = 0.7,
  className = '',
  once = true,
  ...rest
}) => {
  const offset = directionMap[direction] ?? directionMap.up;

  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, ...offset }}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      viewport={{ once, margin: '-60px' }}
      transition={{
        duration,
        delay,
        ease: [0.4, 0, 0.2, 1],
      }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export default ScrollReveal;
